// ======================================================
// context/AuthContext.js
// ======================================================

import {
  createContext,
  useEffect,
  useState,
} from "react";

import {
  storePatientSession,
  getPatientPersona,
  updatePatientPersona,
  clearAuthStorage,
  isAuthenticated,
} from "../utils/storage/authStorage";

// ======================================================
// CONTEXT
// ======================================================

export const AuthContext =
  createContext();

// ======================================================
// PROVIDER
// ======================================================

export const AuthProvider = ({
  children,
}) => {
  // ====================================================
  // STATE
  // ====================================================

  const [user, setUser] =
    useState(null);

  const [loading, setLoading] =
    useState(true);

  // ====================================================
  // RESTORE SESSION
  // ====================================================

  useEffect(() => {
    restoreSession();
  }, []);

  const restoreSession = () => {
    try {
      const userData =
        getPatientPersona();

      const hasUser =
        userData &&
        Object.keys(userData)
          .length > 0;

      if (hasUser) {
        setUser(userData);
      } else {
        setUser(null);
      }
    } catch (error) {
      console.error(
        "restoreSession error:",
        error
      );

      
      logout();
    } finally {
      setLoading(false);
    }
  };

  // ====================================================
  // LOGIN
  // ====================================================

  const login = (
    response = {}
  ) => {
    const storedUser =
      storePatientSession(
        response
      );

    setUser(storedUser);

    return storedUser;
  };

  // ====================================================
  // UPDATE USER
  // ====================================================

  const updateUser = (
    payload = {}
  ) => {
    const updatedUser =
      updatePatientPersona(
        payload
      );

    setUser(updatedUser);

    return updatedUser;
  };

  // ====================================================
  // MARK VERIFIED
  // ====================================================

  const markVerified = () => {
    updateUser({
      isVerified: true,
      mobileVerified: true,
    });
  };

  // ====================================================
  // LOGOUT
  // ====================================================

  const logout = () => {
    clearAuthStorage();

    setUser(null);
  };

  // ====================================================
  // PROVIDER
  // ====================================================

  return (
    <AuthContext.Provider
      value={{
        user,

        loading,

        login,

        logout,

        updateUser,

        markVerified,

        isAuthenticated:
          isAuthenticated(),
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};